import ScrollReveal from 'scrollreveal';

const isSSR = typeof window === 'undefined';
const mockSrFn = {
  reveal: () => {},
  sync: () => {},
};
const sr = isSSR ? mockSrFn : ScrollReveal();
export default sr;
